import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-sesion-expirada',
    templateUrl: './modal-sesion-expirada.component.html',
    styleUrls: ['./modal-sesion-expirada.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalSesionExpiradaComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalSesionExpiradaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
  }
  
  closeDialog() {
    this.dialogRef.close();
  }

}
